import { Stack, Typography } from "@mui/material";
import styled from "@mui/material/styles/styled";

const Background = styled(Stack)({
  backgroundColor: "rgba(0, 0, 0, 0.4)",
  color: "#FFF",
  borderRadius: "2px",
  width: "fit-content",
  padding: "2px 3px",
});

const VideoMetricOverlay = ({
  label,
  value,
}: {
  label: string;
  value?: number | null;
}) => {
  if (value == null) return null;
  return (
    <Background>
      <Typography variant="bodyPrimaryMed" sx={{ fontFamily: "Inter" }}>
        {label}: {value}
      </Typography>
    </Background>
  );
};

export default VideoMetricOverlay;
